<template>
    <div>
        <b-modal ref="modal-company-assessment-member" size="xl" :title="`${company_request_project_code} - 평가 참여자 관리`"
                 body-class="bg-white"
                 :no-close-on-backdrop="is_opend_request_access_modal || is_editing_request_role || is_editing_request_access || is_participating_assessment || is_adding_participatent_searched_users"
                 :no-close-on-esc="is_opend_request_access_modal || is_editing_request_role || is_editing_request_access || is_participating_assessment || is_adding_participatent_searched_users"
                 hide-footer
                 centered
                 @hidden="initializeCompanyAssessmentMember"
        >

            <b-row>
                <b-col cols="12">
                    <div class="d-flex align-items-center">
                        <h5>평가 참여자</h5>
                        <fa icon="question-circle" class="ml-2" style="margin-top: -5px" @click="openHelpModal"></fa>
                    </div>

                    <!-- 한 신청 건의 참여자라 캠페인은 모든 행이 같다 — 행마다 쓰지 않고 표 위에 한 번 (프로젝트 코드는 창 제목) -->
                    <p v-if="memberCampaign" class="small text-secondary mb-2">
                        캠페인: {{ memberCampaign.campaign_name || '-' }} ({{ memberCampaign.campaign_id }})
                    </p>

                    <!-- DS 표 규칙: 행 44 고정 — 칸마다 한 줄, 넘치면 줄이고 전체는 title. 폭은 머리가 정한다.
                         창(모달)은 셸 밖이라 ds-table 을 붙인 표에만 공통 모양이 걸린다 -->
                    <b-table :items="company_request_member"
                             :fields="memberFields"
                             responsive="lg"
                             table-class="ds-table ds-table-fixed assessment-member-table"
                    >
                        <template #cell(user_name)="data">
                            <span class="ds-ellipsis" :title="`${data.value || '-'} (ID ${data.item.user_id}) · ${data.item.e_mail || '-'}`">{{ data.value }} <span class="ds-sub">{{ data.item.e_mail }}</span></span>
                        </template>

                        <template #cell(user_company_name)="data">
                            <span class="ds-ellipsis" :title="`${data.value || '-'} (${data.item.company_id})`">{{ data.value }} <span class="ds-sub">{{ data.item.company_id }}</span></span>
                        </template>

                        <!-- 소속 기업과 같으면 이름을 되풀이하지 않는다(전체는 title) -->
                        <template #cell(request_company_name)="data">
                            <span v-if="data.item.request_company_id == null" class="ds-sub">-</span>
                            <span v-else-if="data.item.request_company_id === data.item.company_id" class="ds-sub"
                                  :title="`${data.value || '-'} (${data.item.request_company_id})`">소속과 같음</span>
                            <span v-else class="ds-ellipsis" :title="`${data.value || '-'} (${data.item.request_company_id})`">{{ data.value }} <span class="ds-sub">{{ data.item.request_company_id }}</span></span>
                        </template>

                        <template #cell(role)="data">
                            <span v-if="request_role[data.value]" class="ds-status" :class="`ds-status-${request_role_variant[data.value]}`">{{ request_role[data.value] }}</span>
                            <span v-else class="ds-sub">미참여</span>
                        </template>

                        <template #cell(access_status)="data">
                            <span v-if="request_access[data.value]" class="ds-status" :class="`ds-status-${request_access_variant[data.value]}`">{{ request_access[data.value] }}</span>
                            <span v-else class="ds-sub">미참여</span>
                        </template>

                        <template #head(managing)="data">
                            <span class="sr-only">{{ data.label }}</span>
                        </template>

                        <!-- 행 액션(아이콘 28): 미참여면 평가 참여, 참여 중이면 관리 메뉴. 메뉴 항목 · 막힘 조건 · 스피너는 예전 그대로 -->
                        <template #cell(managing)="data">
                            <button v-if="!request_role[data.item.role] && !request_access[data.item.access_status]"
                                    type="button" class="ds-row-icon-btn"
                                    :disabled="is_participating_assessment"
                                    :aria-label="`${memberName(data.item)} 평가 참여`" :title="`${memberName(data.item)} 평가 참여`"
                                    @click="participateAssessment(data.item)"
                            >
                                <b-spinner v-if="is_participating_assessment && data.item.user_id === participating_assessment_user_id" small/>
                                <AppIcon v-else name="user-plus"/>
                            </button>
                            <!-- 막힌 토글은 hover 를 못 받으므로 이유는 감싼 span 의 title 로 -->
                            <span v-else class="d-inline-flex align-middle"
                                  :title="data.item.role === 2 ? '평가 관리자는 관리할 수 없습니다. 다른 참여자를 관리자로 지정하면 바뀝니다.' : null"
                            >
                                <b-dropdown variant="link" no-caret right boundary="viewport" menu-class="py-0"
                                            toggle-class="ds-row-icon-btn"
                                            :toggle-attrs="{ 'aria-label': `${memberName(data.item)} 관리`, title: `${memberName(data.item)} 관리` }"
                                            :disabled="data.item.role === 2"
                                >
                                    <template #button-content><AppIcon name="dots-vertical"/></template>
                                    <template v-if="data.item.role !== 2 || data.item.access_status !== 0">
                                        <b-dropdown-item-btn
                                            :disabled="is_editing_request_role || data.item.access_status !== 0 || data.item.role === 2"
                                            @click="managingManagerRole(data.item, data.index)"
                                        >
                                            관리자 지정
                                            <b-spinner v-show="is_editing_request_role && data.item.user_id === editing_request_role_user_id"></b-spinner>
                                        </b-dropdown-item-btn>
                                    </template>

                                    <b-dropdown-item-btn
                                        :disabled="is_editing_request_access"
                                        @click="managingAccess(data.item, data.index)"
                                    >
                                        참여상태 변경
                                        <b-spinner v-show="is_editing_request_access && data.item.user_id === editing_request_access_user_id"></b-spinner>
                                    </b-dropdown-item-btn>

                                    <template v-if="data.item.access_status > 0">
                                        <b-dropdown-item-btn
                                            :disabled="is_editing_request_access"
                                            @click="deleteAssessmentMember(data.item, data.index)"
                                        >
                                            평가 제외
                                            <b-spinner v-show="is_editing_request_access && data.item.user_id === editing_request_access_user_id"></b-spinner>
                                        </b-dropdown-item-btn>
                                    </template>
                                </b-dropdown>
                            </span>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <template v-if="!readOnly">
                <b-row>
                    <b-col cols="12">
                        <div class="py-4">
                            <hr>
                        </div>
                    </b-col>
                </b-row>

                <!-- 소속 유저 (접기/펼치기) -->
                <b-card no-body class="mb-3">
                    <template #header>
                        <div class="d-flex align-items-center justify-content-between" style="height: 36px">
                            <h6 class="mb-0">
                                소속 유저
                                <b-badge variant="secondary" class="ml-1">{{ selected_company_user.length }}</b-badge>
                            </h6>
                            <div class="d-flex align-items-center">
                                <template v-if="showInternalUsers">
                                    <b-btn variant="primary" class="mr-1" size="sm"
                                           :disabled="is_disabled_global_managing_assessment_participant"
                                           @click="add_assessment_participant('in')"
                                    >
                                        {{ add_participant_progress || `평가 참여자 추가하기 (${selected_users.in.length}명)` }}
                                    </b-btn>
                                    <b-btn variant="danger" size="sm" class="mr-2"
                                           :disabled="is_disabled_global_managing_assessment_participant"
                                           @click="$refs['admin-assessment-company-users'].clearSelected()"
                                    >
                                        선택 초기화
                                    </b-btn>
                                </template>
                                <b-btn variant="outline-secondary" size="sm"
                                       @click="showInternalUsers = !showInternalUsers"
                                >
                                    {{ showInternalUsers ? '숨기기' : '보이기' }}
                                </b-btn>
                            </div>
                        </div>
                    </template>
                    <b-collapse :visible="showInternalUsers">
                        <!-- DS 표 규칙(창 안 · ds-table): 열은 아래 검색 결과 표와 같은 순서(선택 | 사용자 | 이메일) -->
                        <b-table ref="admin-assessment-company-users"
                                 :items="selected_company_user"
                                 :fields="internalUserFields"
                                 sticky-header="300px"
                                 select-mode="multi"
                                 responsive="sm"
                                 empty-text="소속 유저가 없습니다."
                                 class="mb-0"
                                 table-class="ds-table ds-table-fixed assessment-company-user-table"
                                 show-empty
                                 selectable
                                 @row-selected="rows => onSearchedUsersSelected(rows, 'in')"
                        >
                            <!-- 체크박스 클릭은 b-table 이 행 클릭으로 보지 않으므로 직접 선택을 바꾼다 -->
                            <template #cell(selected)="{ item, rowSelected, selectRow, unselectRow }">
                                <b-form-checkbox :checked="rowSelected" :aria-label="`${memberName(item)} 선택`" @change="checked => checked ? selectRow() : unselectRow()" />
                            </template>
                            <template #cell(user_name)="data">
                                <span class="ds-ellipsis" :title="`${data.value || '-'} (ID ${data.item.user_id})`">{{ data.value }} <span class="ds-sub">{{ data.item.user_id }}</span></span>
                            </template>
                            <template #cell(e_mail)="data">
                                <span class="ds-ellipsis" :title="data.value">{{ data.value }}</span>
                            </template>
                            <template #empty="scope">
                                <div class="text-center">
                                    <h6 class="mb-0">{{ scope.emptyText }}</h6>
                                </div>
                            </template>
                        </b-table>
                    </b-collapse>
                </b-card>

                <!-- 사용자 검색 (통합) -->
                <b-form @submit="searchUser">
                    <b-card no-body>
                        <template #header>
                            <div class="d-flex align-items-center justify-content-between">
                                <h6 class="mb-0">사용자 검색</h6>
                                <div class="text-right">
                                    <b-btn variant="primary"
                                           class="mr-1"
                                           size="sm"
                                           :disabled="is_disabled_global_managing_assessment_participant || !hasSearchCondition"
                                           type="submit"
                                    >
                                        <b-spinner v-if="is_searching_users" small class="mr-1"/>
                                        조회하기
                                    </b-btn>
                                    <b-btn variant="danger"
                                           size="sm"
                                           type="reset"
                                           :disabled="is_disabled_global_managing_assessment_participant"
                                           @click="initializeUserSearchForm"
                                    >
                                        초기화
                                    </b-btn>
                                </div>
                            </div>
                        </template>
                        <div class="py-3">
                            <div class="px-3">
                                <p class="small text-secondary mb-2">입력한 조건 중 하나라도 맞는 사용자를 찾습니다.</p>
                                <b-form-row>
                                    <b-col cols="12" md="6" lg="3">
                                        <b-form-group
                                            id="fieldset-assessment-user-form-company_id"
                                            label="기업 ID"
                                            label-for="input-assessment-user-form-company_id"
                                        >
                                            <b-form-input id="input-assessment-user-form-company_id"
                                                          v-model="searchUserForm.company_id"
                                                          :disabled="is_disabled_global_managing_assessment_participant"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="3">
                                        <b-form-group
                                            id="fieldset-assessment-user-form-company_name"
                                            label="기업명"
                                            label-for="input-assessment-user-form-company_name"
                                        >
                                            <b-form-input id="input-assessment-user-form-company_name"
                                                          v-model="searchUserForm.company_name"
                                                          :disabled="is_disabled_global_managing_assessment_participant"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6" lg="3">
                                        <b-form-group
                                            id="fieldset-assessment-user-form-e_mail"
                                            label="이메일 (계정 ID)"
                                            label-for="input-assessment-user-form-e_mail"
                                        >
                                            <b-form-input id="input-assessment-user-form-e_mail"
                                                          v-model="searchUserForm.e_mail"
                                                          :disabled="is_disabled_global_managing_assessment_participant"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6" lg="3">
                                        <b-form-group
                                            id="fieldset-assessment-user-form-user_name"
                                            label="이름"
                                            label-for="input-assessment-user-form-user_name"
                                        >
                                            <b-form-input id="input-assessment-user-form-user_name"
                                                          v-model="searchUserForm.user_name"
                                                          :disabled="is_disabled_global_managing_assessment_participant"
                                                          trim
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>
                                <p v-if="emptySearchAttempted && !hasSearchCondition" class="small text-danger mb-0">
                                    검색 조건을 하나 이상 입력해주세요.
                                </p>
                            </div>
                            <!-- 검색 전에는 숨기고, 검색 후에는 0건이어도 결과 영역을 보인다 -->
                            <template v-if="searched">
                                <div>
                                    <hr>
                                </div>
                                <div class="px-3">
                                    <b-card no-body>
                                        <template #header>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <h6 class="mb-0">검색 결과</h6>
                                                <div class="text-right">
                                                    <b-btn variant="primary" class="mr-1" size="sm"
                                                           :disabled="is_disabled_global_managing_assessment_participant || !searchedUsers.length"
                                                           @click="add_assessment_participant('out')"
                                                    >
                                                        {{ add_participant_progress || `평가 참여자 추가하기 (${selected_users.out.length}명)` }}
                                                    </b-btn>
                                                    <b-btn variant="danger" size="sm"
                                                           :disabled="is_disabled_global_managing_assessment_participant || !searchedUsers.length"
                                                           @click="$refs['admin-assessment-searched-users'].clearSelected()"
                                                    >
                                                        선택 초기화
                                                    </b-btn>
                                                </div>
                                            </div>
                                        </template>

                                        <!-- DS 표 규칙(창 안 · ds-table): 소속 유저 표와 같은 선택 칸 · 열 순서. 기업 ID · 사용자 ID 는 이름 옆에 흐리게 -->
                                        <b-table ref="admin-assessment-searched-users"
                                                 :items="searchedUsers"
                                                 :fields="searchedUsersFields"
                                                 :busy="is_searching_users"
                                                 sticky-header="400px"
                                                 select-mode="multi"
                                                 responsive="sm"
                                                 empty-text="조회된 유저가 없습니다."
                                                 class="mb-0"
                                                 table-class="ds-table ds-table-fixed assessment-searched-user-table"
                                                 :selectable="!!searchedUsers.length"
                                                 show-empty
                                                 @row-selected="rows => onSearchedUsersSelected(rows, 'out')"
                                        >
                                            <!-- 체크박스 클릭은 b-table 이 행 클릭으로 보지 않으므로 직접 선택을 바꾼다 -->
                                            <template #cell(selected)="{ item, rowSelected, selectRow, unselectRow }">
                                                <b-form-checkbox :checked="rowSelected" :aria-label="`${memberName(item)} 선택`" @change="checked => checked ? selectRow() : unselectRow()" />
                                            </template>
                                            <template #cell(user_name)="data">
                                                <span class="ds-ellipsis" :title="`${data.value || '-'} (ID ${data.item.user_id})`">{{ data.value }} <span class="ds-sub">{{ data.item.user_id }}</span></span>
                                            </template>
                                            <template #cell(e_mail)="data">
                                                <span class="ds-ellipsis" :title="data.value">{{ data.value }}</span>
                                            </template>
                                            <template #cell(company_name)="data">
                                                <span class="ds-ellipsis" :title="`${data.value || '-'} (${data.item.company_id || '-'})`">{{ data.value }} <span class="ds-sub">{{ data.item.company_id }}</span></span>
                                            </template>
                                            <template #empty="scope">
                                                <div class="text-center">
                                                    <h6 class="mb-0">{{ scope.emptyText }}</h6>
                                                </div>
                                            </template>
                                        </b-table>
                                    </b-card>
                                </div>
                            </template>
                        </div>
                    </b-card>
                </b-form>
            </template>
        </b-modal>

        <b-modal ref="managing-request-access"
                 title="평가 관리 - 참여상태"
                 :no-close-on-backdrop="is_editing_request_access"
                 :no-close-on-esc="is_editing_request_access"
                 @hidden="initializeManagingAccess"
        >

            <b-form-group
                id="fieldset-managing-access-company"
                label="평가참여 기업"
                label-for="input-managing-access-company"
            >
                <b-form-input id="input-managing-access-company" v-model="editing_request_access.request_company_name" disabled />
            </b-form-group>

            <b-form-group
                id="fieldset-managing-access-email"
                label="사용자 계정"
                label-for="input-managing-access-email"
            >
                <b-form-input id="input-managing-access-email" v-model="editing_request_access.e_mail" disabled />
            </b-form-group>

            <b-form-group
                id="fieldset-managing-access-role"
                label="평가참여 역할"
                label-for="input-managing-access-role"
            >
                <b-form-select id="input-managing-access-role" v-model="editing_request_access.access_status" :options="request_access_options" />
            </b-form-group>

            <!-- {{ editing_request_access?.access_status }} -->

            <template #modal-footer>
                <div class="text-right">
                    <b-btn variant="primary" :disabled="is_editing_request_access || (typeof editing_request_access?.request_idx !== 'undefined' && company_request_member[editing_request_access.request_idx]['access_status'] == editing_request_access['access_status'])"
                           class="mr-1"
                           @click="updateAssessmentAccess"
                    >
                        저장하기
                    </b-btn>
                    <b-btn variant="danger"
                           :disabled="is_editing_request_access"
                           @click="$refs['managing-request-access'].hide()"
                    >
                        취소
                    </b-btn>
                </div>
            </template>
        </b-modal>
        <b-modal id="help-modal"
                 title="도움말"
        >
            <template>
                <div class="bg-light p-3">
                    <!-- 평가 참여자 추가 -->
                    <h5 class="fw-bold mb-3">평가 참여자 추가</h5>
                    <ul class="mb-4">
                        <li class="mb-2">
                            <span class="fw-semibold">외부 기업 사용자</span>
                            <ul>
                                <li>
                                    사용자 조회를 통해
                                    <span class="text-primary">현재 캠페인에 연결되지 않은 기업의 사용자</span>
                                    를 캠페인에 추가 가능.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span class="fw-semibold">내부 기업 사용자</span>
                            <ul>
                                <li>
                                    <span class="text-primary">현재 캠페인에 연결되어 있는 기업의 사용자</span>
                                    를 캠페인에 추가 가능.
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <!-- 평가 참여자 관리 -->
                    <h5 class="fw-bold mb-3">평가 참여자 관리</h5>
                    <ul class="mb-4">
                        <li>평가 참여자를 최초로 추가하면 평가 참여자로 추가되고, 참여 상태가
                            <b-badge class="f-80 font-weight-normal" :variant="request_access_variant[1]">
                                {{ request_access[1] }}
                            </b-badge></li>
                        <li>참여 상태, 역할 등을 변경할 수 있고, 평가 참여자 목록에서 제거 가능</li>
                    </ul>

                    <!-- 참고사항 -->
                    <h5 class="fw-bold mb-3">참고사항</h5>
                    <ul class="mb-2">
                        <li>평가 관리자는 <span class="fw-semibold">단 한 명만 존재</span> 가능</li>
                        <li>
                            권한 관리를 통해 평가 관리자 지정 시,
                            <ul>
                                <li>기존 관리자는 권한 박탈되고, 새로운 평가 관리자가 지정됨</li>
                            </ul>
                        </li>
                    </ul>
                    <div class="ms-3">
                        <div class="fw-semibold mb-1">참여 상태에 따른 권한 관리</div>
                        <ul>
                            <li>
                                <b-badge class="f-80 font-weight-normal" :variant="request_access_variant[1]">
                                    {{ request_access[1] }}
                                </b-badge>, <b-badge class="f-80 font-weight-normal" :variant="request_access_variant[2]">
                                {{ request_access[2] }}
                            </b-badge>
                                : 관리자 지정 불가</li>
                            <li><b-badge class="f-80 font-weight-normal" :variant="request_access_variant[0]">
                                {{ request_access[0] }}
                            </b-badge>: 평가 제외 불가</li>
                        </ul>
                    </div>
                </div>
            </template>


        </b-modal>
        <b-modal id="add-participant-mode-modal"
                 title="평가 참여자 추가 옵션"
                 centered
                 ok-title="추가"
                 cancel-title="취소"
                 @ok="executeAddParticipant"
        >
            <p class="mb-3">
                <strong>{{ pendingAddUsers.length }}명</strong>의 사용자를 평가에 추가합니다.
            </p>
            <b-form-group label="참여 상태" class="mb-3">
                <b-form-radio-group v-model="addParticipantMode.approve" stacked>
                    <b-form-radio :value="false">승인 대기</b-form-radio>
                    <b-form-radio :value="true">바로 승인</b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <b-form-group label="메일 발송" class="mb-0">
                <b-form-radio-group v-model="addParticipantMode.sendMail" stacked>
                    <b-form-radio :value="false">발송 안 함</b-form-radio>
                    <b-form-radio :value="true" disabled>
                        승인 메일 발송
                        <b-badge variant="secondary" class="ml-1">준비 중</b-badge>
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { getMemberErrorText } from '@shared/components/admin/pages/Management/Company/data';

const emptySearchUserForm = () => ({ company_id: null, company_name: null, e_mail: null, user_name: null });

// 선택 칸(40) — 소속 유저 · 검색 결과 표 공용. 좌우 여백은 style 의 select-cell 에서 8 로 줄인다
const selectField = { key: 'selected', label: '', thStyle: { width: '40px' }, thClass: 'text-center select-cell', tdClass: 'text-center select-cell' };

// 평가 참여자 관리 모달. 부모가 ref 로 manageProjectMember(project) 를 호출해 연다(열리면 true). 닫히면 'closed'.
// selected_company: { company_id, company_name, member: [...] }
// project: { request_id, project_code, campaign_id }
export default {
    name: 'AdminCompanyAssessmentMemberModal',
    components: {
        fa: FontAwesomeIcon
    },
    props: {
        selected_company: {
            type: Object,
            default: () => ({})
        },
        readOnly: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showInternalUsers: false,

            // 기업 평가별 멤버 관리
            company_request_project_code: null,
            company_request_member: [],
            
            request_role: {
                1: '평가 참여자',
                2: '평가 관리자',
            },
            request_role_variant: {
                1: 'secondary',
                2: 'primary',
            },
            request_access: {
                0: '승인',
                1: '대기',
                2: '거부'
            },
            request_access_variant: {
                0: 'success',
                1: 'info',
                2: 'warning'
            },
            request_role_options: [
                { text: '대기중', value: 0 },
                { text: '참여자', value: 1 },
                { text: '관리자', value: 2 }
            ],

            request_access_options: [
                { text: '참여 승인', value: 0 },
                { text: '승인 대기중', value: 1 },
                { text: '참여 거부', value: 2 }
            ],

            // 평가 참여자 관리 모달 상태관리
            managing_assessment_info: null,
            is_opend_request_access_modal: false,

            //  ~ 참여상태 관련
            editing_request_access: {},
            is_editing_request_access: false,
            editing_request_access_user_id: null,

            //  ~ 평가 관리자 관련
            is_editing_request_role: false,
            editing_request_role_user_id: null,

            //  ~ 평가 참여자 추가 관련
            is_participating_assessment: false,
            participating_assessment_user_id: null,

            // 외부 평가자 조회 및 추가 관련
            //  ~ 외부 평가자 조회
            searchUserForm: emptySearchUserForm(),
            is_searching_users: false,
            // 검색을 한 번이라도 했는지 (0건과 검색 전을 구분)
            searched: false,
            emptySearchAttempted: false,
            // 폭 없는 사용자 · 이메일 · 기업이 남는 폭을 나눠 갖는다(ds-table-fixed)
            searchedUsersFields: [
                selectField,
                { key: 'user_name', label: '사용자' },
                { key: 'e_mail', label: '이메일' },
                { key: 'company_name', label: '기업' },
            ],
            searchedUsers: [],
            selected_company_user: [],
            // 표마다 선택을 따로 둔다 (in: 소속 유저, out: 검색 결과). 추가 버튼을 누른 표의 선택만 추가한다
            selected_users: { in: [], out: [] },
            pendingAddUsers: [],

            //  ~ 참여자 추가
            is_adding_participatent_searched_users: false,
            add_participant_progress: '',
            addParticipantMode: { approve: false, sendMail: false },
        };
    },
    computed: {
        internalUserFields() {
            return [
                selectField,
                { key: 'user_name', label: '사용자' },
                { key: 'e_mail', label: '이메일' },
            ];
        },
        // DS 표 규칙: 폭 없는 사용자 · 소속 기업 · 평가 참여 기업이 남는 폭을 나눠 갖는다(ds-table-fixed)
        memberFields() {
            return [
                { key: 'user_name', label: '사용자' },
                { key: 'user_company_name', label: '소속 기업' },
                { key: 'request_company_name', label: '평가 참여 기업' },
                { key: 'role', label: '평가 역할', thStyle: { width: '104px' } },
                { key: 'access_status', label: '참여 상태', thStyle: { width: '96px' } },
                { key: 'managing', label: '관리', thClass: 'text-right', tdClass: 'text-right', thStyle: { width: '64px' } },
            ];
        },
        // 같은 request_id 로 조회해 모든 행의 캠페인이 같다 — 캠페인이 붙은 첫 행
        memberCampaign() {
            return this.company_request_member.find(member => member.campaign_id) || null;
        },
        is_disabled_searching_adding_searched_users () {
            return this.is_adding_participatent_searched_users || this.is_searching_users;
        },
        is_disabled_global_managing_assessment_participant () {
            return this.is_disabled_searching_adding_searched_users;
        },
        // 앞뒤 공백을 뺀 값이 있는 조건만 보낸다 (빈 문자열만 가면 서버가 전체 사용자를 돌려준다)
        searchUserParams() {
            return Object.entries(this.searchUserForm).reduce((acc, [key, value]) => {
                const text = value == null ? '' : String(value).trim();
                if (text) acc[key] = text;
                return acc;
            }, {});
        },
        hasSearchCondition() {
            return Object.keys(this.searchUserParams).length > 0;
        },
        map_company_request_member(){
            const map = {};
            this.company_request_member.forEach(elem => {
                map[elem.user_id] = elem;
            });
            return map;
        }
    },
    watch: {
        company_request_member() {
            this.selected_company_user = this.selected_company_user.map(elem => {
                if(this.map_company_request_member[elem.user_id])
                    elem._rowVariant  = 'row-disabled-admin-company-assessment';
                else
                    delete elem._rowVariant;
                return elem;
            });
            this.sortInternalUsers();
            if(this.searchedUsers.length > 0){
                this.searchedUsers = this.searchedUsers.map(elem => {
                    if(this.map_company_request_member[elem.user_id])
                        elem._rowVariant  = 'row-disabled-admin-company-assessment';
                    else
                        delete elem._rowVariant;
                    return elem;
                });
            }
        },
        selected_company:{
            deep: true,
            handler(){
                this.selected_company_user = this.selected_company.member.map(elem => {
                    elem.company_name = this.selected_company.company_name;
                    if(this.map_company_request_member[elem.user_id]){
                        elem._rowVariant  = 'row-disabled-admin-company-assessment';
                    }
                    return elem;
                });
                this.sortInternalUsers();
            }
        }
    },
    created(){
        this.selected_company_user = this.selected_company.member.map(elem => {
            elem.company_name = this.selected_company.company_name;
            if(this.map_company_request_member[elem.user_id]){
                elem._rowVariant  = 'row-disabled-admin-company-assessment';
            }
            return elem;
        });
        this.sortInternalUsers();
    },
    methods: {
        openHelpModal(){
            this.$bvModal.show('help-modal');
        },
        // 행 버튼 aria-label · title 에 쓸 사용자 이름(없으면 이메일)
        memberName(member) {
            return member.user_name || member.e_mail || member.user_id;
        },
        async searchUser (event) {
            event.preventDefault();
            if (!this.hasSearchCondition) {
                this.emptySearchAttempted = true;
                return;
            }
            try {
                this.is_searching_users = true;
                this.searchedUsers = [];
                const _searched_user = await this.$axios.get('/admin/users', { params: this.searchUserParams });

                this.searchedUsers = _searched_user.data.map(elem => {
                    if(this.map_company_request_member[elem.user_id]) {
                        elem._rowVariant  = 'row-disabled-admin-company-assessment';
                    }
                    return elem;
                });
                this.searched = true;
            } catch (error) {
                console.error(error);
                this.searched = false;
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', '사용자 검색', getMemberErrorText(error, '외부 기업 사용자를 조회하지 못했습니다.'));
            } finally {
                this.is_searching_users = false;
            }
        },
        initializeUserSearchForm () {
            this.searchUserForm = emptySearchUserForm();
            this.emptySearchAttempted = false;
        },
        onSearchedUsersSelected (rows, type){
            this.selected_users[type] = rows;
        },
        add_assessment_participant (type = 'out') {
            if(this.selected_users[type].length === 0) {
                this.$EventBus.$emit('toast-failure', '참여자 추가', '사용자를 선택해주세요.');
                return;
            }
            this.pendingAddUsers = this.selected_users[type];
            this.addParticipantMode = { approve: false, sendMail: false };
            this.$bvModal.show('add-participant-mode-modal');
        },
        async executeAddParticipant() {
            const { approve, sendMail } = this.addParticipantMode;
            const users = this.pendingAddUsers;
            const failures = [];
            const joined = [];
            const label = (user) => user.e_mail || user.user_name || user.user_id;

            try {
                this.is_adding_participatent_searched_users = true;

                for (const [idx, _searched_user] of users.entries()) {
                    this.add_participant_progress = `추가 중 (${idx + 1}/${users.length})`;
                    try {
                        await this.participateAssessment(_searched_user, {refresh: false});
                        joined.push(_searched_user);
                    } catch (error) {
                        failures.push(`${label(_searched_user)}: ${getMemberErrorText(error, '추가 실패')}`);
                    }
                }

                if (approve) {
                    for (const _searched_user of joined) {
                        try {
                            await this.$axios.post('/admin/assessment/member/approval', {
                                campaign_id: this.managing_assessment_info.campaign_id,
                                company_id: this.selected_company.company_id,
                                user_id: _searched_user.user_id,
                                status: 0
                            });
                        } catch (error) {
                            failures.push(`${label(_searched_user)}: 승인 실패 - ${getMemberErrorText(error, '승인 처리 실패')}`);
                        }
                    }
                }

                // 목록 갱신 (사용자마다가 아니라 마지막에 한 번)
                const _res = await this.$axios.get('/admin/assessment/member', {
                    params: { company_id: this.selected_company.company_id, request_id: this.managing_assessment_info.request_id }
                });
                this.company_request_member = _res.data;

                if (failures.length > 0) {
                    this.$EventBus.$emit('toast-warning', '참여자 추가',
                        `${users.length}명 중 ${joined.length}명 추가, ${failures.length}건 실패했습니다. ${failures.join(' / ')}`);
                } else if (sendMail) {
                    // TODO: 메일 발송 API 연동
                    this.$EventBus.$emit('toast-success', '참여자 추가', `${joined.length}명 추가 완료. (메일 발송 기능은 준비 중입니다)`);
                } else {
                    const statusText = approve ? '승인' : '승인 대기';
                    this.$EventBus.$emit('toast-success', '참여자 추가', `${joined.length}명 추가 완료 (${statusText})`);
                }
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', '참여자 추가', getMemberErrorText(error, '사용자 추가 도중 오류가 발생했습니다.'));
            } finally {
                this.is_adding_participatent_searched_users = false;
                this.add_participant_progress = '';
                if(this.$refs['admin-assessment-searched-users']){
                    this.$refs['admin-assessment-searched-users'].clearSelected();
                }
                if(this.$refs['admin-assessment-company-users']){
                    this.$refs['admin-assessment-company-users'].clearSelected();
                }
            }
        },
        sortInternalUsers() {
            this.selected_company_user.sort((a, b) => {
                const aDisabled = a._rowVariant ? 1 : 0;
                const bDisabled = b._rowVariant ? 1 : 0;
                return aDisabled - bDisabled;
            });
        },
        async manageProjectMember (project) {
            try {
                this.managing_assessment_info = project;
                const { request_id, project_code } = project;
                this.company_request_project_code = project_code;
                const _res_company_request_member = await this.$axios.get('/admin/assessment/member', {
                    params: { company_id: this.selected_company.company_id, request_id }
                });

                this.company_request_member = _res_company_request_member.data;

                this.$refs['modal-company-assessment-member'].show();
                return true;
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '평가 참여자', getMemberErrorText(error, '평가 참여자 데이터를 불러오지 못했습니다.'));
                return false;
            }
        },
        managingAccess (_request, _request_idx) {
            this.editing_request_access = {
                request_idx: _request_idx,
                ..._request
            };

            this.is_opend_request_access_modal = true;

            this.$nextTick(() => {
                this.$refs['managing-request-access'].show();
            });
        },
        async deleteAssessmentMember(_request, _request_idx){
            const confirmed = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '평가 제외',
                message: `[${_request.e_mail || _request.user_name}] 님을 프로젝트 ${this.company_request_project_code} 평가에서 제외합니다. 참여 이력이 삭제되며 다시 참여시키려면 재추가가 필요합니다.`,
            });
            if (!confirmed) {
                return;
            }
            try {
                this.is_editing_request_access = true;
                this.editing_request_access_user_id = _request.user_id;
                const {user_id, request_id} = _request;
                await this.$axios.delete('/admin/assessment/member', {
                    params: { user_id, request_id }
                });

                this.company_request_member = this.company_request_member.reduce((acc, cur) => {
                    if (cur.user_id !== user_id) {
                        acc.push(cur);
                    }
                    return acc;
                },[]);

                this.$EventBus.$emit('toast-success', '평가 제외', '평가 참여자를 제외하였습니다.');
            }
            catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', '평가 제외', getMemberErrorText(error, '평가 제외 처리 도중 오류가 발생했습니다.'));
            }
            finally {
                this.editing_request_access_user_id = null;
                this.is_editing_request_access = false;
            }
        },
        initializeManagingAccess () {
            this.editing_request_access = {};
            this.is_opend_request_access_modal = false;
        },
        // refresh=false 면 실패 시 throw (일괄 추가가 집계). 단건 버튼은 여기서 토스트로 알린다
        async participateAssessment (member, {refresh = true} = {}) {
            try {
                this.participating_assessment_user_id = member.user_id;
                this.is_participating_assessment = true;
                await this.$axios.post('/admin/assessment/member/join', {
                    campaign_id: this.managing_assessment_info.campaign_id,
                    company_id: this.selected_company.company_id,
                    user_id: member.user_id
                });

                if (refresh) {
                    const _res_company_request_member = await this.$axios.get('/admin/assessment/member', {
                        params: { company_id: this.selected_company.company_id, request_id: this.managing_assessment_info.request_id }
                    });

                    this.company_request_member = _res_company_request_member.data;
                }
            } catch (error) {
                if (refresh) {
                    this.$EventBus.$emit('toast-failure', '평가 참여', getMemberErrorText(error, '평가 참여 처리 도중 오류가 발생했습니다.'));
                } else {
                    throw error;
                }
            } finally {
                this.is_participating_assessment = false;
                this.participating_assessment_user_id = null;
            }
        },
        // 다른 프로젝트로 다시 열 때 이전 검색·선택이 남지 않게 모두 비운다
        initializeCompanyAssessmentMember () {
            this.managing_assessment_info = null;
            this.searchedUsers = [];
            this.searched = false;
            this.initializeUserSearchForm();
            this.selected_users = { in: [], out: [] };
            this.pendingAddUsers = [];
            this.showInternalUsers = false;
            this.$emit('closed');
        },
        async updateAssessmentAccess () {
            try {
                this.is_editing_request_access = true;
                const { campaign_id, request_company_id, user_id, access_status } = this.editing_request_access;
                this.editing_request_access_user_id = user_id;

                await this.$axios.post('/admin/assessment/member/approval', {
                    campaign_id, company_id: request_company_id, user_id, status: access_status
                });

                const _res_company_request_member = await this.$axios.get('/admin/assessment/member', {
                    params: { company_id: this.selected_company.company_id, request_id: this.managing_assessment_info.request_id }
                });

                this.company_request_member = _res_company_request_member.data;

                this.$nextTick(() => {
                    this.$refs['managing-request-access'].hide();
                });
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', '참여상태 변경', getMemberErrorText(error, '평가 참여상태 처리 도중 오류가 발생했습니다.'));
            } finally {
                this.editing_request_access_user_id = null;
                this.is_editing_request_access = false;
            }
        },
        async managingManagerRole (_request, _request_idx) {
            const current_manager = this.company_request_member.find(({ role }) => role === 2);
            if (!current_manager) {
                this.$EventBus.$emit('toast-failure', '관리자 지정', '관리자가 조회되지 않습니다.');
                return;
            }
            const confirmed = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '관리자 지정',
                message: `[${_request.e_mail || _request.user_name}] 님을 평가 관리자로 지정합니다. 기존 관리자 [${current_manager.e_mail || current_manager.user_name}] 님은 관리자 권한을 잃습니다.`,
            });
            if (!confirmed) {
                return;
            }
            try {
                this.is_editing_request_role = true;
                this.editing_request_role_user_id = _request.user_id;

                await this.$axios.post('/admin/assessment/member/manager', {
                    current_manager_id: current_manager.user_id,
                    next_manager_id: _request.user_id,
                    company_id: _request.request_company_id,
                    campaign_id: _request.campaign_id
                });

                const _res_company_request_member = await this.$axios.get('/admin/assessment/member', {
                    params: { company_id: this.selected_company.company_id, request_id: this.managing_assessment_info.request_id }
                });

                this.company_request_member = _res_company_request_member.data;
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', '관리자 지정', getMemberErrorText(error, '관리자 변경 처리 도중 오류가 발생했습니다.'));
            } finally {
                this.is_editing_request_role = false;
                this.editing_request_role_user_id = null;
            }
        },
    }
};
</script>

<style lang="scss">
// 창(xl) 본문 폭: 1200 이상 1080(1140 - 좌우 여백 30씩), 992~1199 는 740 — 그 안에 들어가게, 더 좁으면 가로 스크롤.
// 참여자 표: 고정 264(역할 104 · 상태 96 · 관리 64) + 사용자 · 소속 · 참여 기업 152씩
.modal .table.assessment-member-table {
    min-width: 720px;
}
// 소속 유저 표(카드 테두리 안 ~738): 선택 40 + 사용자 · 이메일 240씩
.modal .table.assessment-company-user-table {
    min-width: 520px;
}
// 검색 결과 표(카드 · px-3 · 카드 안 ~706): 선택 40 + 사용자 · 이메일 · 기업 200씩
.modal .table.assessment-searched-user-table {
    min-width: 640px;
}
// 선택 칸(40)은 좌우 여백 8 — 공통 16 이면 체크박스가 칸을 넘친다
.modal .table.ds-table.assessment-company-user-table,
.modal .table.ds-table.assessment-searched-user-table {
    > thead > tr > th.select-cell,
    > tbody > tr > td.select-cell {
        padding-left: 8px;
        padding-right: 8px;
    }
}

.table-row-disabled-admin-company-assessment {
    background-color: #f8f9fa !important;
    color: #adb5bd !important;
    pointer-events: none !important;
    td {
        background-color: #f8f9fa !important;
        color: #adb5bd !important;
        cursor: not-allowed;
    }
}
</style>
